import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { TESTIMONIALS } from '../data/testimonials';

const Testimonials = () => {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setI((v) => (v + 1) % TESTIMONIALS.length), 6000);
    return () => clearInterval(t);
  }, [paused]);

  const prev = () => setI((v) => (v - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setI((v) => (v + 1) % TESTIMONIALS.length);

  const t = TESTIMONIALS[i];

  return (
    <section
      className="bg-white py-20 md:py-24"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="max-w-[1100px] mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[11px] tracking-[0.3em] text-[#c9a961] font-medium mb-5">
            CLIENT VOICES
          </p>
          <h2
            className="font-serif text-4xl md:text-5xl text-[#1c1e20] mb-3"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}
          >
            Trusted by discerning clients.
          </h2>
          <div className="w-16 h-[2px] bg-[#c9a961] mx-auto" />
        </div>

        <div className="relative bg-[#faf6f0] border border-black/5 px-6 md:px-16 py-14 md:py-16 min-h-[300px] flex items-center">
          <Quote
            size={64}
            className="absolute top-6 left-6 md:left-10 text-[#c9a961]/25"
            strokeWidth={1}
          />

          <div className="w-full text-center relative z-10 transition-opacity duration-500" key={`slide-${t.name}`}>
            <p
              className="font-serif text-2xl md:text-3xl text-[#1c1e20] leading-[1.4] italic max-w-3xl mx-auto"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}
            >
              &ldquo;{t.quote}&rdquo;
            </p>
            <div className="w-10 h-[2px] bg-[#c9a961] mx-auto my-6" />
            <p className="text-[13px] tracking-[0.22em] font-semibold text-[#1c1e20]">
              {t.name.toUpperCase()}
            </p>
            <p className="text-[12px] text-[#6b6b6b] mt-1">
              {t.title} &middot; {t.location}
            </p>
          </div>

          <button
            onClick={prev}
            aria-label="Previous"
            className="hidden md:flex absolute left-4 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full border border-[#c9a961] items-center justify-center text-[#c9a961] hover:bg-[#c9a961] hover:text-white transition-colors"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            onClick={next}
            aria-label="Next"
            className="hidden md:flex absolute right-4 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full border border-[#c9a961] items-center justify-center text-[#c9a961] hover:bg-[#c9a961] hover:text-white transition-colors"
          >
            <ChevronRight size={18} />
          </button>
        </div>

        <div className="flex items-center justify-center gap-2 mt-8">
          {TESTIMONIALS.map((t, idx) => (
            <button
              key={`dot-${t.name}`}
              onClick={() => setI(idx)}
              aria-label={`Testimonial ${idx + 1}`}
              className={`h-[3px] transition-all duration-300 ${
                idx === i ? 'w-10 bg-[#c9a961]' : 'w-4 bg-[#c9a961]/30'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
